import {
    COLLECTIONITEMS_REQUEST,
    COLLECTIONITEMS_SUCCESS,
    COLLECTIONITEMS_FAILURE,
    COLLECTIONITEMSMORE_SUCCESS
} from "../constants/ActionTypes";

const initialState = {
    loading: false,
    products: [],
    count: null,
    error: null,
};

export default function landingReducer(state = initialState, action) {
    switch (action.type) {
        case COLLECTIONITEMS_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case COLLECTIONITEMS_SUCCESS:
            return {
                ...state,
                loading: false,
                // always replacing data
                count: action.products.products.length,
                products: action.products.products
                // if adding data
                // data: [...state.data, action.data]
            };
        case COLLECTIONITEMSMORE_SUCCESS:
            return {
                ...state,
                loading: false,
                // always replacing data
                count: action.products.length,
                products: [...state.products, ...action.products.products]
                // if adding data
                // data: [...state.data, action.data]
            };
        case COLLECTIONITEMS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        default:
            return state;
    }
}
